import React from "react";
import { motion } from "framer-motion";

// A thin-line, editorial data-chart motif used in the hero.
export const ChartMotif = ({ className = "" }) => {
  const bars = [38, 62, 48, 78, 56, 92, 70];
  const line = "M0,150 C40,120 70,90 110,110 C150,130 180,60 220,80 C260,100 300,40 340,55";

  return (
    <svg
      viewBox="0 0 360 220"
      className={className}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      {/* baseline */}
      <line x1="0" y1="200" x2="360" y2="200" stroke="#1C1C1E" strokeOpacity="0.15" strokeWidth="1" />
      {/* thin gridlines */}
      {[40, 80, 120, 160].map((y) => (
        <line key={y} x1="0" y1={y} x2="360" y2={y} stroke="#1C1C1E" strokeOpacity="0.06" strokeWidth="1" />
      ))}

      {/* bars */}
      {bars.map((h, i) => (
        <motion.rect
          key={i}
          x={12 + i * 30}
          width="14"
          rx="2"
          fill={i === 5 ? "#B39B77" : "#3E4A5C"}
          fillOpacity={i === 5 ? 1 : 0.28}
          initial={{ height: 0, y: 200 }}
          animate={{ height: h, y: 200 - h }}
          transition={{ duration: 1, ease: [0.16, 1, 0.3, 1], delay: 0.6 + i * 0.08 }}
        />
      ))}

      {/* trend line */}
      <motion.path
        d={line}
        stroke="#B39B77"
        strokeWidth="2.5"
        strokeLinecap="round"
        initial={{ pathLength: 0 }}
        animate={{ pathLength: 1 }}
        transition={{ duration: 1.6, ease: "easeInOut", delay: 1 }}
      />
      {/* endpoint dot */}
      <motion.circle
        cx="340"
        cy="55"
        r="5"
        fill="#B39B77"
        initial={{ scale: 0 }}
        animate={{ scale: 1 }}
        transition={{ duration: 0.4, delay: 2.5 }}
      />
    </svg>
  );
};
